import { createFileRoute } from "@tanstack/react-router";
import { createSocialHeadMeta } from "~/lib/social-head";
import { PRIVATE_CREDIT_SOCIAL_METADATA } from "~/lib/social-metadata";
import { createRwaMarketsRouteLoader } from "~/features/rwa-markets/rwa-markets-route-loader";

export const Route = createFileRoute("/_app/private-credit")({
  head: () => ({
    meta: createSocialHeadMeta(PRIVATE_CREDIT_SOCIAL_METADATA),
  }),
  loader: createRwaMarketsRouteLoader("private-credit"),
});
